import React from 'react'
import {SessionReport} from 'tutorapp-components'
import { useState , useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { apiService } from '../utils/apiRequest';
import { setComment, setPracticeWorkGiven, setNotes, setPracticeWorkGivenDetail } from '../redux/actions/sessionActions';

export default function Sessionreportscreen() {

//chatgpt api credentials from env file.
const  chatgptkey = process.env.REACT_APP_CHATGPTAUTH
const  chatgptorgid = process.env.REACT_APP_CHAT_GPT_ORG_ID


const [Loading ,setLoading] = useState(false)
const [studenName , setStudentName] =  useState()


//for getting tutorname 
const tutorname = useSelector((state) => {
  const { first_name, last_name } = state.auth.userData;
  return last_name ? `${first_name} ${last_name}` : first_name;
});


 


  const dispatch = useDispatch()
  const sessions = useSelector((state) => state.session);
  const sessionnotes = sessions?.notes
  const navigate = useNavigate()

  //for getting student details name for chatgpt api
  const studentDetails = async (studentid) => {
   
     try {
       
       setLoading(true)
       const getAppointmentDetails = process.env.REACT_APP_API_URL + 'getStudentName'
       const options = {
         method: "POST",
         headers: {
           "Content-Type": "application/json",
         },
         body: JSON.stringify({
          student_ids: studentid,
         }),
       };
   
       const response = await apiService(getAppointmentDetails, options);
   
       if (response.status == 'success') {
         setStudentName(Object.values(response.data.valid_students).join(", "));
         setLoading(false)

       } else {
         console.error("Failed to reschedule appointment:", response.message);
       }
     } catch (error) {
       console.error("Error while rescheduling appointment:", error);
     }
     finally{
      setLoading(false)
 
     }
   };
 
//for navigating to next session page
const handleNextSession = (data) => {

  const sessiondetails = {

    sessiondetails: data
  }
  dispatch(setComment(data?.comment))
  dispatch(setNotes(data?.notes))
  dispatch(setPracticeWorkGiven(data?.practice_work_given))
  dispatch(setPracticeWorkGivenDetail(data?.practice_work_given_detail))

    navigate("/next-session")

}

const gptkey = {
  chatgptkey : chatgptkey,
  chatgptorgid: chatgptorgid


}

const handleback = () => {

 const appointmentfor = sessions?.appointmentFor
  if(appointmentfor ==='Families' ){
  navigate("/session-date-time")
}
else {    
  navigate("/MyAppointment")

}
}


//for calling  student details api
useEffect(() => {
  const studentId = sessions?.sessionStudent; // Replace with actual student ID source
  studentDetails(studentId);
}, []);

    const sessionnotesdata = {
      studentname : studenName,
      tutorName :  tutorname,
      session_remaininghour :  sessions?.sessionRemainingHour,
      sessionnotedata : sessionnotes
    }



  return (
    <div>
        <SessionReport
        gptkey={gptkey}
        handlesessionback={handleback}
        sessionnotesdata={sessionnotesdata}
        icons={{
        sessionappointment: "./images/ic_back.svg",
        close: "./images/ic_close.svg",
        progress: "./images/ic_two.svg",
        useai: "./images/ai.svg",
      }}
        handleNextSession={handleNextSession}
        handleback={handleback}
        appointmentFor={sessions}
        
        />
        
        </div>
  )
}
